export default __webpack_public_path__ + "static/media/volGasoil.9eedfcea.png";